/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {LayoutIncludeListPageComponent} from './layout-include-list-page.component';

@Component({
  standalone: true,
  imports: [LayoutIncludeListPageComponent],
  selector: 'adn-layout-include-route-page',
  template: `
    <adn-layout-include-list-page [readOnly]="readOnly"></adn-layout-include-list-page>
  `
})
export class LayoutIncludeRoutePageComponent {
  @Input() readOnly = false;
}
